




















import { Component, Prop, Mixins, Emit, Ref } from 'vue-property-decorator';
import Vue from 'vue';
import { MoreIcon } from '@/components/icons/MoreIcon';
import BaseMixin from '@/mixins/BaseMixin';
import { ShoppingCartItem } from '../../../entities/ShoppingCartItem';

@Component
export default class CartItems extends Mixins(BaseMixin) {
    @Prop(Array)
    private cartItems!: ShoppingCartItem[];
    @Prop(String)
    private partDetailLink!: string;

    private partDetailLinkForCartItem(cartItem: ShoppingCartItem): string {
        return `${this.partDetailLink}${encodeURIComponent(
            cartItem.fullPartId
        )}`;
    }
}
